import React from 'react';
import {useState} from 'react'
import useGlobalContext from '../Context/useGlobalContext'
import config from '../config.json'
import RadioGroupComponent from '../commonComponents/RadioGroupComponent'
import { _MapStyle } from '../App'

const MapStyle = () => {
    const mapStyleData: _MapStyle[] = config.mapStyles
    const {currentMapStyle, setCurrentMapStyle } = useGlobalContext()
    const [selectedValue, setSelectedValue] = useState(currentMapStyle.value);

    const onChange = (value: string) => {
        const mapStyle = mapStyleData.find((item) => item.value === value)
        setCurrentMapStyle(mapStyle!!)
        setSelectedValue(value)
    }
    // <RadioGroupComponent
        // data={mapStyleData}
        // onChange={onChange}
        // selected={selectedValue}
        // />
    return(
    
        <RadioGroupComponent
        name={'mapStyle'}
        value={selectedValue}
        fields={mapStyleData}
        onSelect={onChange}
      />
    )

}

export default MapStyle;